import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components'
import { NavContentBlueprint } from '@backstage/plugin-app-react'
import { SidebarLogo } from './SidebarLogo'
import { RiMenuLine, RiSearchLine } from '@remixicon/react'
import { SidebarSearchModal } from '@backstage/plugin-search'
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings'
import { NotificationsSidebarItem } from '@backstage/plugin-notifications'

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ))

      // Skipped items
      nav.take('page:search') // Using search modal instead
      nav.take('page:notifications') // Using NotificationsSidebarItem manually instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup
            label="Search"
            icon={<RiSearchLine size={20} />}
            to="/search"
          >
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<RiMenuLine size={20} />}>
            {nav.take('page:home')}
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      )
    },
  },
})
